import {
    SingleValueDataType,
    ValueTypeDefinitions,
    PromptDataType,
    UseCaseTypes,
} from 'Types/Tasks.types'
import styles from '../Prompt.module.less'
import { PromptContent } from 'Components/tasks/Prompt/Prompt'

type PromptMultiMediaContentPropsType = {
    content: SingleValueDataType<keyof ValueTypeDefinitions>[][]
    useCase: UseCaseTypes
    id: string
}

export const PromptMultiMediaContent = (props: PromptMultiMediaContentPropsType) => {
    return (
        <div className={styles['multi-media-content']}>
            {props.content.map((rowItem, rowIndex) => (
                <div className={styles['row']} key={rowIndex + '-' + props.id}>
                    {rowItem.map((item, index) => (
                        <div className={styles['item']} key={props.id + '-' + index}>
                            <PromptContent
                                type={item.value_type}
                                value={item.value as PromptDataType}
                                useCase={props.useCase}
                                id={`${props.id}[${rowIndex}][${index}]`}
                            />
                        </div>
                    ))}
                </div>
            ))}
        </div>
    )
}
